import { HttpResponseCodes } from '@wetransfer/transfer/modules/http/axios/response';

export const validationError = (type: string, mimeType: string): string =>
  mimeType.startsWith('video')
    ? `${type}_upload_validation_error_videos`
    : `${type}_upload_validation_error`;

export const generateErrorMessage = (
  status: number,
  type: string,
  mimeType = ''
): string => {
  switch (status) {
    case HttpResponseCodes.CONFLICT:
    case HttpResponseCodes.BAD_REQUEST:
    case HttpResponseCodes.NOT_FOUND:
      return validationError(type, mimeType);
    default:
      return 'something_went_wrong';
  }
};

export default {
  validationError,
  generateErrorMessage,
};
